import { FC } from 'react';
import { TextField, Autocomplete, Typography, Checkbox } from '@mui/material';
import CheckBoxIcon from '@mui/icons-material/CheckBox';

import './SCUIAutoCompleteInput.scss';

interface IProps {
    onChangeTextField?: any;
    list: any;
    defValue?: any;
    onChange: any;
    multiple?: boolean;
    loading?: boolean;
    txtPlaceHolder?: string;
    searchValue?: string;
    limitTags?: number;
    width?: number;
    border?: any;
    sx?: any;
}

export const SCUIAutoCompleteInput: FC<IProps> = ({
    onChangeTextField,
    multiple = true,
    list,
    defValue,
    onChange,
    loading = false,
    txtPlaceHolder = 'Ara',
    searchValue,
    limitTags = 1,
    width,
    sx = {},
    border,
}) => {
    const labelKey = searchValue || '';
    return (
        list && (
            <Autocomplete
                sx={{
                    ...sx,
                    height: 'auto!important',
                    ...(border && {
                        '& .MuiOutlinedInput-root': {
                            '& fieldset': {
                                borderRadius: 50,
                            },
                        },
                    }),
                }}
                id="asynchronous-demo"
                className="sc-autocomplete"
                multiple={multiple}
                disableClearable
                fullWidth={true}
                disableCloseOnSelect={multiple}
                limitTags={limitTags ? limitTags : 2}
                value={defValue}
                isOptionEqualToValue={(option: any, value: any) =>
                    option?.id != null && value?.id != null ? option.id === value.id : option === value
                }
                getOptionLabel={(option: any) => (option && option[labelKey]) || ''}
                getOptionDisabled={(option) => !!option.autocompleteDisabled}
                options={Array.isArray(list) ? list : []}
                onChange={onChange}
                loading={loading}
                style={{
                    width: width && width,
                }}
                renderOption={(props, option: any, { selected }) => (
                    <li {...props} key={option?.id ?? props.id}>
                        {multiple && <Checkbox checkedIcon={<CheckBoxIcon />} checked={selected} />}
                        <Typography style={{ fontSize: '1.5rem' }}>{option?.[labelKey]}</Typography>
                    </li>
                )}
                noOptionsText={'---'}
                renderInput={(params: any) => {
                    return (
                        <TextField
                            sx={{ height: 'auto' }}
                            {...params}
                            label={txtPlaceHolder}
                            onChange={onChangeTextField}
                        />
                    );
                }}
            />
        )
    );
};
